export const namespaced = true

const initialState = {
  dialog: null
}
export const state = {
  dialog: null
}

export const mutations = {
  OPEN(state, dialog) {
    state.dialog = dialog
  },
  CLOSE(state) {
    state.dialog = null
  },
  SAVE(state) {
    if (state.dialog.save) {
      state.dialog.save()
    }
    state.dialog = null
  },
  CANCEL(state) {
    if (state.dialog.cancel) {
      state.dialog.cancel()
    }
    state.dialog = null
  },
  OK(state) {
    if (state.dialog.ok) {
      state.dialog.ok()
    }
    state.dialog = null
  }
}

export const actions = {
  open({ commit }, dialog) {
    commit('OPEN', dialog)
  },
  close({ commit }) {
    commit('CLOSE')
  },
  save({ commit }) {
    commit('SAVE')
  },
  cancel({ commit }) {
    commit('CANCEL')
  },
  ok({ commit }) {
    commit('OK')
  }
}
export const getters = {
  getDialog: state => {
    return state.dialog
  }
}
